export const NUM_OF_GUESSES_ALLOWED = 6;
export const NUM_OF_LETTERS = 5;
